import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'

export const TabContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',

  '& .MuiButton-root': {
    marginRight: '10px',
    borderRadius: theme.shape.customBorderRadius.main,
  },

  '& .MuiButton-textPrimary.active': {
    backgroundColor: theme.palette.primary.light, //theme.PRIMARY_80
  },

  '& .btn-container': {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  '& .side-component': {
    width: '100px',
    justifyContent: 'space-around',
    padding: 0,
    flexDirection: 'unset',
  },
}))
